import * as yup from 'yup';
import { phoneNumberSchema } from 'Common/functions/PhoneNumber';

const signUpFormValidationSchema = {
  idToken: yup.string().required(),
  timezoneLocation: yup.string().required(),
  placeId: yup.string().required('Please enter your address!'),
  phoneNumber: phoneNumberSchema,
  serviceType: yup.string().required('Please select a service type'),
  utcOffcet: yup.string().notRequired(),
  currency: yup.string().required('Please select a currency')
};

export const signupFormValidationSchema = yup.object(
  signUpFormValidationSchema,
);
